// bao migrate skip
import template from "./user-tagging-template.html";
import * as UserTagging from "./user-tagging-module";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
export default {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var e = componentInfo.element;
            var vm = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    Bao.unbindEvent('user-tagging:save', vm.Save);
                    //vm.dispose();
                }
            });
            vm = new UserTagging.UserTaggingComponent(params, componentInfo.element);
            return vm;
        }
    },
    template: template
};